// import {mixinDayJs, mixinErrorHandler} from "../helpers/vue_mixins";

import Multiselect from 'vue-multiselect'

window.Vue = require('vue').default;
window.Vuex = require('vuex').default;

Vue.use(Vuex);


Vue.component('multiselect', Multiselect)

Vue.component('reset-calendar', require('./admin/components/ResetScheduleCalendar').default);
Vue.component('alert-messages', require('./admin/components/AlertMessages').default);
Vue.component('schedule-filter', require('./admin/components/ScheduleFilterComponent').default);
Vue.component('schedule-calendar', require('./admin/components/ScheduleCalendarComponent').default);
Vue.component('schedule-list', require('./admin/components/ScheduleListComponent').default);
Vue.component('course-schedule', require('./admin/components/CourseScheduleDetailsComponent').default);
Vue.component('course-schedule-create', require('./admin/components/CourseScheduleCreateComponent').default);
Vue.component('course-order', require('./admin/components/CourseOrderDetailsComponent').default);

Vue.mixin(require('./helpers/vue_mixins').mixinErrorHandler);
Vue.mixin(require('./helpers/vue_mixins').mixinDayJs);

window.VuexAdminStore = require('./admin/stores/AdminStore').default;

// if (document.getElementById('adminAppVue')) {
//     const app = require('./admin/AdminApp').default;
// }
